import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api-client"
import type { CustomField } from "@/lib/types"

export function useCustomFields(moduleName: string) {
  return useQuery({
    queryKey: ["custom_fields", moduleName],
    queryFn: () =>
      api.get<{ data: CustomField[] }>(
        `/api/v1/custom_fields?module_name=${encodeURIComponent(moduleName)}`
      ),
    staleTime: 5 * 60 * 1000, // 5 minutes - custom fields rarely change
  })
}
